import { render } from "./CarouselComponents.vue?vue&type=template&id=1c465272"
import script from "./CarouselComponents.vue?vue&type=script&lang=js"
export * from "./CarouselComponents.vue?vue&type=script&lang=js"

import "./CarouselComponents.vue?vue&type=style&index=0&id=1c465272&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/Genesii/COLON/wonderful-colon/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__